<template>
  <v-container fluid class="px-5">
    <ViewTitles class="mx-2">
      <span class="base-title" slot="title">Painel de Controle das Movimentações Cadastrais</span>
    </ViewTitles>

    <v-row align="center" class="mx-1">
      <v-col>
        <v-tabs v-model="tab" color="primary" background-color="transparent">
          <v-tab v-if="hasAuthorityProtocolViewTab" key='fileMovements' href='#fileMovements' style="font-size: 18px" @click="changeTab()">Movimentações via arquivo</v-tab>
          <v-tab v-if="hasAuthorityMovementViewTab" key='movements' href='#movements' style="font-size: 18px" @click="changeTab()">Movimentações</v-tab>
          <v-tab v-if="hasAuthorityBatchViewTab" key='shippingBatches' href='#shippingBatches' style="font-size: 18px" @click="changeTab()">Lote de envio</v-tab>
          <v-tab v-if="hasMyReportViewTab" key='myReports' href='#myReports' style="font-size: 18px" @click="changeTab()">Meus Relatórios</v-tab>
          <v-tab v-if="hasIntegratorMovementsTab" key='integratorMovements' href='#integratorMovements' style="font-size: 18px" @click="changeTab()">Movimentações Integradora</v-tab>
        </v-tabs>
      </v-col>
      <v-col cols="auto" class="d-flex justify-end" v-if="tab !== 'integratorMovements'">
        <CreateMovements />
      </v-col>
    </v-row>

    <v-row align="center" class="mx-1">
      <v-col class="px-2 pt-0">
        <v-expansion-panels v-model="isPanelExpanded">
          <v-expansion-panel>
            <v-expansion-panel-header style="cursor: auto;">
              <v-row @click.stop align="center">
                <v-col>
                  <v-icon small class="mr-2 base-color">fas fa-filter</v-icon>
                  <span class="base-color">Expandir Opções de Pesquisa</span>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="5"
                  lg="3"
                  xl="2"
                  v-if="tab === 'integratorMovements'">
                  <AdvancedSearch
                    @result="integratorMovementFilterSearch = $event"
                    @resetAdvancedSearch="resetIntegratorMovementsAdvancedSearch"
                    :resetAdvancedSearch="resetAdvancedSearch"
                    :items="advancedSearchFilters"
                    :isMultiple="false"
                    placeholder="Busca por nome ou cpf..."
                    isRegular
                    color="primary"
                  />
                </v-col>
                <v-col sm="12" md="7" class="py-2 mr-5" align="end">
                  <DatePickerCustom
                    ref="DatePickerCustom"
                    :tab="tab"
                    :filtersForCheckDate="filtersForCheckDate"
                    :showDateTypes="!['myReports', 'integratorMovements'].includes(tab)"
                    @handlerClickFilter="handlerClickFilter"
                    @clearFilters="clearFilters"
                    @openExpandedContent="openExpandedContent"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <FileMovementsContentFilter
                v-show="tab === 'fileMovements'"
                ref="FileMovementsContentFilter"
                :financialGroups="financialGroups"
                :resetFilterFileMovements="resetFilterFileMovements"
                :isRHProtegido="isRHProtegido"
                :assignedUsers="assignedUsers"
                :serviceUnits="serviceUnits"
                @hasFiltersFileMovements="hasFiltersFileMovements"
                @resetStatusFilters="resetStatusFilters"
              />
              <MovementsContentFilter
                v-show="tab === 'movements'"
                ref="MovementsContentFilter"
                :insuranceCarriers="insuranceCarriers"
                :financialGroups="financialGroups"
                :isRHProtegido="isRHProtegido"
                :updateFilterField="updateFilterField"
                :loadingInsuranceCarriers="loadingInsuranceCarriers"
                :assignedUsers="assignedUsers"
                :serviceUnits="serviceUnits"
                @hasFiltersMovements="hasFiltersMovements"
                @resetStatusFilters="resetStatusFilters"
                @finishinLoading="setLoadingPendingMovementsButton"
                @getInsuranceCarriersByFinancialGroup="getInsuranceCarriersByFinancialGroup"
              />
              <ShippingBatchesContentFilter
                v-show="tab === 'shippingBatches'"
                ref="ShippingBatchesContentFilter"
                :financialGroups="financialGroups"
                :insuranceCarriers="insuranceCarriers"
                :resetFilterShippingBatches="resetFilterShippingBatches"
                @hasFiltersShippingBatches="hasFiltersShippingBatches"
                @resetStatusFilters="resetStatusFilters"
              />
              <MyReportsContentFilter
                v-show="tab === 'myReports'"
                ref="MyReportsContentFilter"
                :isRHProtegido="isRHProtegido"
                :financialGroups="financialGroups"
                :resetFilterMyReports="resetFilterMyReports"
                @hasFiltersMyReports="hasFiltersMyReports"
              />

              <IntegratorMovementsContentFilter
                v-show="tab === 'integratorMovements'"
                ref="IntegratorMovementContentFilter"
                @showMessage="showMessage"
                :isRHProtegido="isRHProtegido"
                :insuranceCarriers="insuranceCarriers"
                :financialGroups="financialGroups"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="px-6">
        <v-tabs-items class="transparent" style="border-radius: 5px;" v-model="tab" grow>
          <v-tab-item key='fileMovements' value='fileMovements'>
            <v-row>
              <FileMovementsTable
                :filterFileMovements="filterFileMovements"
                :financialGroups="financialGroups"
                :resetFilterFileMovements="resetFilterFileMovements"
                :isManager="isManager"
                @updateFilterFileMovement="updateFilterFileMovement"
                @getMovementByProtocolId="getMovementByProtocolId"
                @getMovementByMovementRecordId="getMovementByMovementRecordId"
              />
            </v-row>
          </v-tab-item>

          <v-tab-item key='movements' value='movements'>
            <v-row>
              <MovementsTable
                ref="MovementsTable"
                :financialGroups="financialGroups"
                :contractsProp="contracts"
                :subContractsProp="subContracts"
                :isManager="isManager"
                @goToMyReportsTable="goToMyReportsTable"
              />
            </v-row>
          </v-tab-item>

          <v-tab-item key='shippingBatches' value='shippingBatches'>
            <v-row>
              <ShippingBatchesTable
                :filterShippingBatches="filterShippingBatches"
                :insuranceCarriers="insuranceCarriers"
                :resetFilterShippingBatches="resetFilterShippingBatches"
                :financialGroups="financialGroups"
                @getMovementByMovementInsuranceCarrierId="getMovementByMovementInsuranceCarrierId"
              />
            </v-row>
          </v-tab-item>

          <v-tab-item key='myReports' value='myReports'>
            <v-row>
              <MyReportsTable
                ref="MyReportsTable"
                :isRHProtegido="isRHProtegido"
                :financialGroups="financialGroups"
                :resetFilterMyReports="resetFilterMyReports"
              />
            </v-row>
          </v-tab-item>

          <v-tab-item key='integratorMovements' value='integratorMovements'>
            <v-row>
              <IntegratorMovementsTable
                ref="IntegratorMovementsTable"
                @showMessage="showMessage"
                :insuranceCarriers="insuranceCarriers"
                :financialGroups="financialGroups"
                :isRHProtegido="isRHProtegido"
              />
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-footer class="my-5">
      <v-row class="d-flex justify-end">
        <v-col cols="12" xs="12" sm="12" md="2" lg="2">
          <v-btn x-large block outlined color="primary" @click="onClickBack()">
            Voltar
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>

    <ButtonPendingMovements
      v-if="tab === 'movements'"
      ref="ButtonPendingMovements"
      :isRHProtegido="isRHProtegido"
      @isPendingMovements="isPendingMovements"
    />

    <SnackbarCustomize ref="SnackbarCustomize" />
  </v-container>
</template>

<script>
import ViewTitles from '@/components/PageTitles/ViewTitles.vue';
import DatePickerCustom from '@/components/DashboardMovementRecords/Common/DatePickerCustom.vue';
import FileMovementsTable from '@/components/DashboardMovementRecords/FileMovements/FileMovementsTable.vue';
import FileMovementsContentFilter from '@/components/DashboardMovementRecords/FileMovements/FileMovementsContentFilter.vue';
import VerifyRoutesMixin from '@/shared/mixins/routeManagement/verifyRoutesMixin';
import ShippingBatchesTable from '@/components/DashboardMovementRecords/ShippingBatches/ShippingBatchesTable.vue';
import ShippingBatchesContentFilter from '@/components/DashboardMovementRecords/ShippingBatches/ShippingBatchesContentFilter.vue';
import FinancialGroupsMixin from '@/shared/mixins/sdi/financialGroupsMixin';
import InsuranceCarriersMixin from '@/shared/mixins/sdi/insuranceCarriersMixin';
import MovementsTable from '@/components/DashboardMovementRecords/Movements/MovementsTable.vue';
import MovementsContentFilter from '@/components/DashboardMovementRecords/Movements/MovementsContentFilter.vue';
import AuthorityManagement from '@/shared/mixins/authorityManagement/authorityManagementMixin';
import MovementRecordsMixin from '@/shared/mixins/movementRecords/movementRecordsMixin';
import CreateMovements from '@/components/DashboardMovementRecords/Common/CreateMovements.vue';
import MyReportsContentFilter from '@/components/DashboardMovementRecords/MyReports/MyReportsContentFilter.vue';
import MyReportsTable from '@/components/DashboardMovementRecords/MyReports/MyReportsTable.vue';
import IntegratorMovementsContentFilter from '@/components/DashboardMovementRecords/IntegratorMovements/IntegratorMovementsContentFilter.vue';
import IntegratorMovementsTable from '@/components/DashboardMovementRecords/IntegratorMovements/IntegratorMovementsTable.vue';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import Functions from '@/shared/functions/functions';
import ButtonPendingMovements from '@/components/CustomAlerts/ButtonPendingMovements.vue';
import AdvancedSearch from '@/components/AdvancedSearch/AdvancedSearch.vue';
import { mapActions, mapGetters } from 'vuex';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import MovementAssignmentService from '@/services-http/sdi/MovementAssignmentService';

export default ({
  name: 'MovementRecord',

  components: {
    DatePickerCustom,
    ViewTitles,
    FileMovementsTable,
    FileMovementsContentFilter,
    ShippingBatchesTable,
    ShippingBatchesContentFilter,
    MovementsTable,
    MovementsContentFilter,
    CreateMovements,
    ButtonPendingMovements,
    MyReportsContentFilter,
    MyReportsTable,
    IntegratorMovementsContentFilter,
    IntegratorMovementsTable,
    AdvancedSearch,
    SnackbarCustomize,
  },

  data: () => ({
    tab: 'fileMovements',
    hasAuthorityBatchViewTab: false,
    hasAuthorityProtocolViewTab: false,
    hasAuthorityMovementViewTab: false,
    hasMyReportViewTab: false,
    hasIntegratorMovementsTab: false,
    isRHProtegido: false,
    isManager: false,
    assignedUsers: [],
    serviceUnits: [],
    resetDate: false,
    isPanelExpanded: false,
    resetFilterFileMovements: false,
    resetFilterShippingBatches: false,
    resetFilterMyReports: false,
    updateFilterField: {},

    dataFilter: {},
    dataFilterFileMovements: {},
    dataFilterShippingBatches: {},
    dataFilterMovements: {},
    dataFilterMyReports: {},
    filtersForCheckDate: {},
    filterForCheckFileMovement: {},
    filterForCheckMovement: {},
    filterForCheckShippingBatches: {},
    filterForCheckMyReports: {},
    dateType: [],

    dates: [],
    financialGroups: [],
    insuranceCarriers: [],
    loadingInsuranceCarriers: false,
    contracts: [],
    subContracts: [],
    advancedSearchFilters: [
      { id: 'name', label: 'Nome' },
      { id: 'document', label: 'CPF' },
    ],
    resetAdvancedSearch: false,
  }),

  mixins: [
    VerifyRoutesMixin,
    FinancialGroupsMixin,
    InsuranceCarriersMixin,
    AuthorityManagement,
    MovementRecordsMixin,
  ],

  created() {
    this.functions = new Functions();
  },

  async mounted() {
    this.managementAuthorities();
    this.getFinancialGroups();
    this.getInsuranceCarriers();
    this.verifySessionStorageAndRouteParams();
    await this.loadAssignmentContext();

    if (this.tab === 'fileMovements') {
      this.changeTab();
    }
  },

  watch: {
    tab: {
      handler(newTab, oldTab) {
        switch (oldTab) {
          case 'fileMovements':
            this.filterForCheckFileMovement = this.filtersForCheckDate;
            break;
          case 'shippingBatches':
            this.filterForCheckShippingBatches = this.filtersForCheckDate;
            break;
          case 'movements':
            this.filterForCheckMovement = this.filtersForCheckDate;
            break;
          case 'myReports':
            this.filterForCheckMyReports = this.filtersForCheckDate;
            break;
        }

        switch (newTab) {
          case 'fileMovements':
            this.filtersForCheckDate = this.filterForCheckFileMovement;
            break;
          case 'shippingBatches':
            this.filtersForCheckDate = this.filterForCheckShippingBatches;
            break;
          case 'movements':
            this.filtersForCheckDate = this.filterForCheckMovement;
            break;
          case 'myReports':
            this.filtersForCheckDate = this.filterForCheckMyReports;
            break;
        }
      },
      deep: true
    }
  },

  methods: {
    ...mapActions({
      resetIntegratorMovementFilter: 'integrator-movement/resetFilter',
      setIntegratorMovementFilter: 'integrator-movement/setFilter',
      fetchIntegratorMovements: 'integrator-movement/search',
    }),
    showMessage(messageData) {
      this.$refs.SnackbarCustomize.open(messageData.type, messageData.message);
    },
    normalizeAssignmentOptions(options = []) {
      const optionsById = options.reduce((acc, option) => {
        if (!option || option.id === null || typeof option.id === 'undefined') return acc;
        return {
          ...acc,
          [option.id]: {
            id: option.id,
            name: option.name,
          },
        };
      }, {});

      return Object.values(optionsById);
    },
    getCurrentUserId() {
      const session = this.userUtils.getUserSessionStorage();
      return session && session.user ? session.user.id : null;
    },
    resolveIsManager(users = []) {
      const currentUserId = this.getCurrentUserId();
      if (currentUserId === null || typeof currentUserId === 'undefined') {
        return false;
      }

      return users.some((user) => String(user.id) !== String(currentUserId));
    },
    async loadAssignmentContext() {
      if (this.isRHProtegido) return;

      const assignmentService = new MovementAssignmentService();

      try {
        const unitsResponse = await assignmentService.getAvailableUnits();
        this.serviceUnits = this.normalizeAssignmentOptions(unitsResponse && unitsResponse.data ? unitsResponse.data : []);

        const structureIds = this.serviceUnits.map((structure) => structure.id);
        const usersResponse = await assignmentService.getResponsibleUsers(structureIds);
        this.assignedUsers = this.normalizeAssignmentOptions(usersResponse && usersResponse.data ? usersResponse.data : []);
        this.isManager = this.resolveIsManager(this.assignedUsers);
      } catch {
        this.serviceUnits = [];
        this.assignedUsers = [];
        this.isManager = false;
      }
    },
    verifySessionStorageAndRouteParams() {
      if (sessionStorage.getItem('searchParams')) {
        const session = JSON.parse(sessionStorage.getItem('searchParams'));
        this.tab = session.tab;
      } else if (this.$route.params.movement) {
        this.tab = 'movements';
        this.changeTab();
      }
    },
    managementAuthorities() {
      this.hasAuthorityBatchViewTab = !!(this.hasPermission('sdi_painel_movimentacoes_cadastrais_visualizar_lote') && !this.isRHProtegido);
      this.hasAuthorityProtocolViewTab = this.hasPermission('sdi_painel_movimentacoes_cadastrais_visualizar_protocolo');
      this.hasAuthorityMovementViewTab = this.hasPermission('sdi_painel_movimentacoes_cadastrais_visualizar_movimentacao');
      this.hasMyReportViewTab = this.hasPermission('sdi_painel_movimentacoes_cadastrais_visualizar_movimentacao');
      this.hasIntegratorMovementsTab = !!(this.hasPermission('sdi_aba_movimentacao_integradora') && !this.isRHProtegido);
    },
    handlerClickFilter(dates, dateType) {
      if (dates && dates.length > 0) {
        this.processDates(dates, dateType);
      } else {
        this.dates = [];
      }

      const commonFilterProperties = this.setCommonFilterProperties();

      this.handleTabFiltering(commonFilterProperties);
    },
    processDates(dates, dateType) {
      const startDate = moment(dates[0]);
      const endDate = moment(dates[1]);
      this.dateType = dateType;

      this.dates[0] = this.setDateTimezone(startDate.startOf('day'))
      this.dates[1] = this.setDateTimezone(endDate.endOf('day').add(3, 'hours'))

      this.dates[0] = this.formatDate(this.dates[0])
      this.dates[1] = this.formatDate(this.dates[1])
    },
    setDateTimezone(date) {
      return date.add(3, 'hours')
    },
    formatDate(date) {
      return date.format('YYYY-MM-DDTHH:mm:ss.SSS');
    },
    setCommonFilterProperties() {
      return {
        startDate: this.dates[0],
        endDate: this.dates[1],
        dateType: this.dateType,
      };
    },
    updateFilterFileMovement(key, value) {
      this.filterFileMovements[key] = value;
    },
    async handleTabFiltering(commonFilterProperties) {
      switch (this.tab) {
        case 'fileMovements':
          this.handleFileMovements();
          break;
        case 'shippingBatches':
          this.handleShippingBatches(commonFilterProperties);
          break;
        case 'movements':
          this.handleMovements(commonFilterProperties);
          break;
        case 'myReports':
          this.handleMyReports(commonFilterProperties);
          break;
        case 'integratorMovements':
          this.setIntegratorMovementFilter({
            createdDateStart: this.dates[0],
            createdDateEnd: this.dates[1],
          });

          await this.fetchIntegratorMovements();
          break;
        default:
          console.error(`Unsupported tab: ${this.tab}`);
          break;
      }
    },
    handleFileMovements() {
      this.resetFilterFileMovements = false;
      this.filterFileMovements = {
        ...this.dataFilterFileMovements,
        receivingDateStart: this.dates[0],
        receivingDateEnd: this.dates[1],
      };
    },
    handleShippingBatches(commonFilterProperties) {
      this.resetFilterShippingBatches = false;
      this.filterShippingBatches = {
        ...this.dataFilterShippingBatches,
        ...commonFilterProperties,
      };
    },
    handleMovements(commonFilterProperties) {
      let filters = { ...this.dataFilterMovements };

      const hasPartialSuccessStatus =
        Array.isArray(filters.status) && filters.status.some(
          (movementStatus) => movementStatus === 'PARTIAL_FINISH');

      if (hasPartialSuccessStatus) {
        const statusFilter = {
          isPartialFinished: true,
        };

        filters = {
          ...filters,
          ...statusFilter,
        };
      }

      const filterMovements = {
        ...filters,
        ...commonFilterProperties,
      };

      this.$refs.MovementsTable.handlerFilter(filterMovements, 'click');
    },
    handleMyReports(commonFilterProperties) {
      this.resetFilterMyReports = false;

      this.filterMyReports = {
        ...this.dataFilterMyReports,
        receivingDateStart: this.dates[0],
        receivingDateEnd: this.dates[1],
      };

      setTimeout(() => {
        this.$refs.MyReportsTable.handlerFilter(this.filterMyReports, 'click');
      }, 200);
    },
    hasFiltersFileMovements(data, type) {
      this.dataFilterFileMovements = cloneDeep(data);
      this.filtersForCheckDate = cloneDeep(data);
      if (type === 'getFilterByFavorite') {
        this.$refs.DatePickerCustom.getFilterByFavorite(data);
      }
    },
    hasFiltersShippingBatches(data, type) {
      this.dataFilterShippingBatches = cloneDeep(data);
      if (type === 'getFilterByFavorite') {
        this.$refs.DatePickerCustom.getFilterByFavorite(data);
      }
    },
    hasFiltersMovements(data, type) {
      this.dataFilterMovements = cloneDeep(data.filterMovements);
      this.filtersForCheckDate = cloneDeep(data.filterMovements);
      this.contracts = data.contracts;
      this.subContracts = data.subContracts;
      if (type === 'getFilterByFavorite') {
        this.$refs.DatePickerCustom.getFilterByFavorite(data.filterMovements);
      }
    },
    hasFiltersMyReports(data, type) {
      this.dataFilterMyReports = cloneDeep(data);
    },
    async getMovementByMovementRecordId(id, status) {
      await this.setMovementFilter('movement', id, status);
    },
    async getMovementByProtocolId(id, status) {
      await this.setMovementFilter('protocol', id, status);
    },
    async getMovementByMovementInsuranceCarrierId(id, status) {
      await this.setMovementFilter('batch', id, status);
    },
    async setMovementFilter(type, id, status) {
      const idNumber = Number(id);
      this.tab = 'movements';
      this.isPanelExpanded = 0;

      sessionStorage.setItem('hasFilter', true);
      this.filterMovements.protocolNumber = type === 'protocol' ? idNumber : '';
      this.filterMovements.movementRecordId = type === 'movement' ? idNumber : '';
      this.filterMovements.movementInsuranceCarrierId = type === 'batch' ? idNumber : '';

      if (status) {
        this.filterMovements.status = [status];
      }
      this.updateFilterField = {
        movementInsuranceCarrierId: this.filterMovements.movementInsuranceCarrierId,
        movementRecordId: this.filterMovements.movementRecordId,
        protocolNumber: this.filterMovements.protocolNumber
      }

      setTimeout(() => {
        this.$refs.MovementsTable.handlerFilter(this.filterMovements);
      }, 200);
    },
    resetGetFilterMovement() {
      this.$refs.MovementsTable.getFilterMovement();
    },
    onClickBack() {
      this.redirectRouter('HomeAllMenus', { isRHProtegido: this.isRHProtegido });
    },
    clearFilters() {
      switch(this.tab) {
        case 'fileMovements':
          this.resetFilterFileMovements = true;
          break;
        case 'movements':
          this.$refs.MovementsContentFilter.clearFilterMovements();
          break;
        case 'shippingBatches':
          this.resetFilterShippingBatches = true;
          break;
        case 'myReports':
          this.resetFilterMyReports = true;
          break;
        case 'integratorMovements':
          this.resetAdvancedSearch = true;
          this.resetIntegratorMovementFilter();
          break;
      }
    },
    resetStatusFilters(data) {
      if (this.tab === 'fileMovements') {
        this.resetFilterFileMovements = data;
      }
      if (this.tab === 'shippingBatches') {
        this.resetFilterShippingBatches = data;
      }
      if (this.tab === 'myReports') {
        this.resetFilterMyReports = data;
      }
    },
    openExpandedContent(value) {
      this.isPanelExpanded = value;
    },
    changeTab() {
      const keysToPreserve = ['theme', '@auth/token', '@auth/user', 'selectedDate', 'movementRecordIds','@sdi/app_origin'];
      this.functions.clearSessionStorage(keysToPreserve);

      this.updateFilterField = {}

      this.requestDataTable(100);
    },
    requestDataTable(time) {
      setTimeout(() => {
        this.$refs.DatePickerCustom.handlerFilter();
      }, time);
    },
    async isPendingMovements() {
      this.openExpandedContent(0);

      const datePickerTimeout = 200;
      const movementsTableTimeout = 100;

      await new Promise((resolve) => setTimeout(resolve, datePickerTimeout));
      this.$refs.DatePickerCustom.setNoDate();

      await new Promise((resolve) => setTimeout(resolve, movementsTableTimeout));
      this.$refs.MovementsContentFilter.verifySessionStorage('isPendingMovements');
    },
    setLoadingPendingMovementsButton(value, filterMovements) {
      filterMovements.pendingMovements = true;
      this.$refs.ButtonPendingMovements.setLoadingButton(value);
      this.$refs.MovementsTable.handlerFilter(filterMovements, 'isPendingMovements');
    },
    goToMyReportsTable() {
      this.tab = 'myReports';
      const commonFilterProperties = this.setCommonFilterProperties();
      this.handleTabFiltering(commonFilterProperties);
    },
    resetIntegratorMovementsAdvancedSearch() {
      setTimeout(() => {
        this.resetAdvancedSearch = false;
      }, 500);
    },
    getInsuranceCarriersByFinancialGroup(financialGroupId) {
      this.getInsuranceCarriers(financialGroupId);
    }
  },

  computed: {
    ...mapGetters({
      integratorMovementFilter: 'integrator-movement/integratorMovementFilter',
    }),
    integratorMovementFilterSearch: {
      get() {
        return this.integratorMovementFilter.document | this.integratorMovementFilter.insuredName;
      },
      set(searchs) {
        const name = searchs.find((el) => el.key === 'name')?.value[0] ?? null;
        const cpf = searchs.find((el) => el.key === 'document')?.value[0] ?? null;
        const cpfFormatted = cpf ? cpf.replace(/\.|-/g, '') : null;

        this.setIntegratorMovementFilter({
          insuredName: name,
          insuredDocumentNumber: cpfFormatted,
        });
      }
    },
  },
});
</script>

<style>
.v-expansion-panel-header__icon {
  cursor: pointer;
}
.v-expansion-panel-header:before {
  background-color: var(--v-muted-base);
}
</style>
